import { useAccount } from 'wagmi'
import { SocialShareMenu } from 'views/LockTools/components/SharePanel'
import { useReferralInfo } from 'views/Social/useReferral'
import { competitionOgUrl, competitionShareTargets, competitionUrl, shareMessage, ShareFacts } from 'views/TradingCompetitionV4/share'

/**
 * "Share to invite traders" (Bez, 2026-10-03): the same networks as the lock certificate plus WhatsApp and Reddit, Copy link and
 * the card as PNG. A connected sharer's link carries their referral id (?ref=<handle or wallet>), so people who arrive through it
 * are invited by them.
 */
export default function CompetitionShare({ facts, label = 'Share', align = 'left', testId = 'comp-share', inline = false, tone = 'gold' }: { facts: ShareFacts; label?: string; align?: 'left' | 'right'; testId?: string; inline?: boolean; tone?: 'gold' | 'ghost' }) {
  const { address } = useAccount()
  const { info } = useReferralInfo(address)
  const origin = typeof window !== 'undefined' ? window.location.origin : 'https://apps.cadinu.io'
  const url = competitionUrl(origin, facts.id, address ? info?.id ?? address : null)
  const text = shareMessage(facts)
  return (
    <SocialShareMenu
      url={url}
      previewSrc={competitionOgUrl(origin, facts.id)}
      previewAlt={`Trading competition #${facts.id}, the card shown in link previews`}
      targets={competitionShareTargets(text, url)}
      downloadHref={competitionOgUrl(origin, facts.id, 2)}
      downloadName={`cadinu-competition-${facts.id}.png`}
      label={label}
      dialogLabel="Share this competition"
      align={align}
      inline={inline}
      tone={tone}
      buttonTestId={testId}
      note={address ? 'The link carries your referral: people who join through it are invited by you.' : 'Connect a wallet first to add your referral to the link.'}
    />
  )
}
